// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MainAppV2.css - Clean Integrated Design */

/* ===== BASE LAYOUT ===== */
.main-app-v2 {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: relative;
  background: linear-gradient(135deg, #FFFBF5 0%, #FEF7ED 100%);
}

/* ===== HEADER ===== */
.floating-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(16px);
  border-radius: 0;
  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  gap: 24px;
}

.logo-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.logo {
  font-size: 24px;
  font-weight: 700;
  color: #F97316;
  letter-spacing: -0.5px;
}

.tagline {
  font-size: 14px;
  color: #6B7280;
  font-weight: 500;
}

/* ===== SEARCH CONTROLS ===== */
.search-controls-inline {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
  justify-content: center;
}

.control-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(248, 250, 252, 0.9);
  border: 1px solid rgba(226, 232, 240, 0.6);
  border-radius: 8px;
  padding: 10px 14px;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
}

.control-pill:hover {
  background: rgba(241, 245, 249, 0.95);
  border-color: rgba(203, 213, 225, 0.8);
  transform: translateY(-1px);
}

.control-emoji {
  font-size: 16px;
}

.control-pill select {
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  outline: none;
}

.refresh-pill {
  background: rgba(243, 244, 246, 0.9);
  border: 1px solid rgba(209, 213, 219, 0.6);
  border-radius: 8px;
  padding: 10px 14px;
  color: #374151;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
}

.refresh-pill:hover:not(:disabled) {
  background: #E5E7EB;
  border-color: #9CA3AF;
  transform: translateY(-1px);
}

.refresh-pill:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.map-type-pill {
  background: rgba(243, 244, 246, 0.9);
  border: 1px solid rgba(209, 213, 219, 0.6);
  border-radius: 8px;
  padding: 10px 14px;
  color: #374151;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
}

.map-type-pill:hover:not(:disabled) {
  background: #E5E7EB;
  border-color: #9CA3AF;
  transform: translateY(-1px);
}

.map-type-pill:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ===== HEADER RIGHT SECTION ===== */
.header-right-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* ===== USER PROFILE ===== */
.user-profile-section {
  position: relative;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(248, 250, 252, 0.9);
  border: 1px solid rgba(226, 232, 240, 0.6);
  backdrop-filter: blur(8px);
}

.user-profile:hover {
  background: rgba(241, 245, 249, 0.95);
  border-color: rgba(203, 213, 225, 0.8);
  transform: translateY(-1px);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.dropdown-arrow {
  color: #9CA3AF;
  transition: transform 0.2s ease;
}

.user-profile:hover .dropdown-arrow {
  transform: translateY(1px);
}

.profile-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: rgba(255, 255, 255, 0.98);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(229, 231, 235, 0.6);
  overflow: hidden;
  min-width: 160px;
  max-width: 200px;
  width: max-content;
  z-index: 1001;
  backdrop-filter: blur(16px);
}

.menu-item {
  display: block;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  font-size: 14px;
  color: #374151;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.menu-item:hover {
  background: #F9FAFB;
}

.menu-item.logout {
  color: #EF4444;
  border-top: 1px solid #F3F4F6;
}

.menu-item.logout:hover {
  background: #FEF2F2;
}

/* ===== MAIN CONTENT ===== */
.app-main-integrated {
  height: 100vh;
  width: 100vw;
  position: relative;
}

.map-container {
  height: 100%;
  width: 100%;
  position: relative;
}

.map {
  height: 100%;
  width: 100%;
  border-radius: 0;
}

.map-loading,
.map-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  background: rgba(255, 255, 255, 0.95);
  padding: 32px;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #E5E7EB;
  border-top: 4px solid #F97316;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 16px;
}

.loading-spinner.small {
  width: 20px;
  height: 20px;
  border-width: 2px;
  margin: 0;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ===== PLACES PANEL ===== */
.floating-places-panel {
  position: fixed;
  top: 80px;
  left: 16px;
  width: 320px;
  max-height: calc(100vh - 96px);
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(12px);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 900;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Hide mobile search controls on desktop */
.mobile-search-controls {
  display: none;
}

.places-scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px 8px 8px 8px;
}

.places-scroll::-webkit-scrollbar {
  width: 6px;
}

.places-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.places-scroll::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 3px;
}

.places-scroll::-webkit-scrollbar-thumb:hover {
  background: #94A3B8;
}

/* ===== PLACE CARDS ===== */
.place-card-compact {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px;
  margin-bottom: 8px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.2s ease;
  backdrop-filter: blur(8px);
}

.place-card-compact:hover {
  border-color: rgba(249, 115, 22, 0.3);
  box-shadow: 0 8px 32px rgba(249, 115, 22, 0.15);
  transform: translateY(-2px);
  background: rgba(255, 255, 255, 0.95);
}

.place-card-compact.selected {
  border-color: rgba(249, 115, 22, 0.4);
  background: rgba(255, 247, 237, 0.9);
  box-shadow: 0 6px 24px rgba(249, 115, 22, 0.2);
}

.place-main-info {
  flex: 1 1;
  min-width: 0;
}

.place-main-info h4 {
  margin: 0 0 4px 0;
  font-size: 16px;
  font-weight: 600;
  color: #1F2937;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.place-meta-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.place-rating,
.place-price {
  font-size: 12px;
  color: #6B7280;
}

.interest-button-compact {
  background: #F3F4F6;
  border: 1px solid #D1D5DB;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.interest-button-compact:hover {
  background: #E5E7EB;
  border-color: #9CA3AF;
}

.interest-button-compact.interested {
  background: #D1FAE5;
  border-color: #10B981;
  color: #10B981;
}

.interest-button-compact.interested:hover {
  background: #A7F3D0;
}

/* Loading Places State */
.loading-places {
  text-align: center;
  padding: 40px 20px;
  color: #6B7280;
}

.loading-places p {
  margin: 16px 0 0 0;
  font-size: 14px;
}

/* No Places State */
.no-places {
  text-align: center;
  padding: 40px 20px;
  color: #6B7280;
}

.no-places-emoji {
  font-size: 48px;
  margin-bottom: 16px;
}

.no-places p {
  margin: 4px 0;
  font-size: 14px;
}

/* ===== PLACE DETAILS ===== */
.selected-place-detail {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 320px;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(16px);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  z-index: 900;
  animation: slideUp 0.3s ease-out;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.detail-header {
  display: flex;
  justify-content: flex-end;
  padding: 12px 16px 0;
}

.close-detail {
  background: #F3F4F6;
  border: none;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  color: #6B7280;
  transition: all 0.2s ease;
}

.close-detail:hover {
  background: #E5E7EB;
  color: #374151;
}

.detail-content {
  padding: 0 20px 20px;
}

.detail-content h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.detail-address {
  margin: 0 0 12px 0;
  font-size: 14px;
  color: #6B7280;
  line-height: 1.4;
}

.detail-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.detail-rating,
.detail-price {
  font-size: 14px;
  color: #374151;
}

.detail-actions {
  text-align: center;
}

.interest-button-large {
  width: 100%;
  background: #F97316;
  border: none;
  border-radius: 6px;
  padding: 12px 16px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-bottom: 8px;
}

.interest-button-large:hover {
  background: #EA580C;
  transform: translateY(-1px);
}

.interest-button-large.interested {
  background: #10B981;
}

.interest-button-large.interested:hover {
  background: #059669;
}

.interest-status {
  font-size: 12px;
  color: #6B7280;
  line-height: 1.4;
}

/* ===== MODALS ===== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  backdrop-filter: blur(4px);
}

.modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #E5E7EB;
}

.modal-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

.close-button {
  background: #F3F4F6;
  border: none;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  color: #6B7280;
  transition: all 0.2s ease;
}

.close-button:hover {
  background: #E5E7EB;
  color: #374151;
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(80vh - 80px);
}

/* Profile Info */
.profile-info {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.profile-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #E5E7EB;
}

.profile-details {
  flex: 1 1;
}

.profile-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #F3F4F6;
}

.profile-field:last-child {
  border-bottom: none;
}

.profile-field label {
  font-weight: 500;
  color: #374151;
  font-size: 14px;
}

.profile-field span {
  color: #6B7280;
  font-size: 14px;
}

/* Settings Content */
.settings-content {
  text-align: center;
  padding: 40px 20px;
}

.settings-message {
  max-width: 300px;
  margin: 0 auto;
}

.settings-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.settings-message h3 {
  margin: 0 0 12px 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}

.settings-message p {
  margin: 0;
  color: #6B7280;
  line-height: 1.5;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
  .floating-header {
    left: 0;
    right: 0;
    top: 0;
    border-radius: 0;
  }
  
  .header-content {
    padding: 12px 16px;
    gap: 12px;
    flex-wrap: nowrap;
    align-items: center;
  }
  
  .logo-section {
    flex: 1 1;
    min-width: 0;
  }
  
  .logo {
    font-size: 20px;
  }
  
  .tagline {
    font-size: 12px;
  }
  
  .search-controls-inline {
    display: none;
  }
  
  .header-right-section {
    flex-shrink: 0;
    gap: 12px;
  }
  
  .user-profile {
    min-width: 44px;
    max-width: 44px;
    padding: 8px;
    justify-content: center;
  }
  
  .user-name {
    display: none;
  }
  
  .dropdown-arrow {
    display: none;
  }
  
  .app-main-integrated {
    display: flex;
    flex-direction: column;
    padding-top: 70px;
    height: 100vh;
  }
  
  .map-container {
    height: 50vh;
    width: 100%;
    flex-shrink: 0;
  }
  
  .floating-places-panel {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    width: 100%;
    max-width: none;
    height: auto;
    max-height: none;
    border-radius: 0;
    border: none;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: none;
    transform: none;
    transition: none;
    flex: 1 1;
    background: rgba(255, 255, 255, 0.98);
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .mobile-search-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: rgba(248, 250, 252, 0.9);
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    flex-wrap: wrap;
  }
  
  .selected-place-detail {
    position: fixed;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100vw - 20px);
    max-width: 300px;
    z-index: 1000;
  }
  
  .modal-content {
    width: 95%;
    margin: 20px;
  }
}

@media (max-width: 480px) {
  .header-content {
    padding: 10px 12px;
    gap: 8px;
  }
  
  .logo {
    font-size: 18px;
  }
  
  .tagline {
    font-size: 11px;
  }
  
  .user-profile {
    min-width: 40px;
    max-width: 40px;
    padding: 6px;
  }
  
  .user-avatar {
    width: 28px;
    height: 28px;
  }
  
  .app-main-integrated {
    padding-top: 60px;
  }
  
  .map-container {
    height: 40vh;
  }
  
  .floating-places-panel {
  }
  
  .selected-place-detail {
    max-width: none;
    top: 45%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/MainAppV2.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C,4BAA4B;AAC5B;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,qCAAqC;EACrC,2BAA2B;EAC3B,gBAAgB;EAChB,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;EAC/C,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE;IACE,OAAO;IACP,QAAQ;IACR,MAAM;IACN,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,SAAO;IACP,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,oCAAoC;IACpC,4CAA4C;IAC5C,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;EACA;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;AACF","sourcesContent":["/* MainAppV2.css - Clean Integrated Design */\n\n/* ===== BASE LAYOUT ===== */\n.main-app-v2 {\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  position: relative;\n  background: linear-gradient(135deg, #FFFBF5 0%, #FEF7ED 100%);\n}\n\n/* ===== HEADER ===== */\n.floating-header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(16px);\n  border-radius: 0;\n  box-shadow: 0 2px 24px rgba(0, 0, 0, 0.06);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 24px;\n  gap: 24px;\n}\n\n.logo-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.logo {\n  font-size: 24px;\n  font-weight: 700;\n  color: #F97316;\n  letter-spacing: -0.5px;\n}\n\n.tagline {\n  font-size: 14px;\n  color: #6B7280;\n  font-weight: 500;\n}\n\n/* ===== SEARCH CONTROLS ===== */\n.search-controls-inline {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n  justify-content: center;\n}\n\n.control-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(248, 250, 252, 0.9);\n  border: 1px solid rgba(226, 232, 240, 0.6);\n  border-radius: 8px;\n  padding: 10px 14px;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(8px);\n}\n\n.control-pill:hover {\n  background: rgba(241, 245, 249, 0.95);\n  border-color: rgba(203, 213, 225, 0.8);\n  transform: translateY(-1px);\n}\n\n.control-emoji {\n  font-size: 16px;\n}\n\n.control-pill select {\n  border: none;\n  background: transparent;\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n  cursor: pointer;\n  outline: none;\n}\n\n.refresh-pill {\n  background: rgba(243, 244, 246, 0.9);\n  border: 1px solid rgba(209, 213, 219, 0.6);\n  border-radius: 8px;\n  padding: 10px 14px;\n  color: #374151;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(8px);\n}\n\n.refresh-pill:hover:not(:disabled) {\n  background: #E5E7EB;\n  border-color: #9CA3AF;\n  transform: translateY(-1px);\n}\n\n.refresh-pill:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.map-type-pill {\n  background: rgba(243, 244, 246, 0.9);\n  border: 1px solid rgba(209, 213, 219, 0.6);\n  border-radius: 8px;\n  padding: 10px 14px;\n  color: #374151;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(8px);\n}\n\n.map-type-pill:hover:not(:disabled) {\n  background: #E5E7EB;\n  border-color: #9CA3AF;\n  transform: translateY(-1px);\n}\n\n.map-type-pill:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ===== HEADER RIGHT SECTION ===== */\n.header-right-section {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* ===== USER PROFILE ===== */\n.user-profile-section {\n  position: relative;\n}\n\n.user-profile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(248, 250, 252, 0.9);\n  border: 1px solid rgba(226, 232, 240, 0.6);\n  backdrop-filter: blur(8px);\n}\n\n.user-profile:hover {\n  background: rgba(241, 245, 249, 0.95);\n  border-color: rgba(203, 213, 225, 0.8);\n  transform: translateY(-1px);\n}\n\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.dropdown-arrow {\n  color: #9CA3AF;\n  transition: transform 0.2s ease;\n}\n\n.user-profile:hover .dropdown-arrow {\n  transform: translateY(1px);\n}\n\n.profile-menu {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: rgba(255, 255, 255, 0.98);\n  border-radius: 8px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  border: 1px solid rgba(229, 231, 235, 0.6);\n  overflow: hidden;\n  min-width: 160px;\n  max-width: 200px;\n  width: max-content;\n  z-index: 1001;\n  backdrop-filter: blur(16px);\n}\n\n.menu-item {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: none;\n  text-align: left;\n  font-size: 14px;\n  color: #374151;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.menu-item:hover {\n  background: #F9FAFB;\n}\n\n.menu-item.logout {\n  color: #EF4444;\n  border-top: 1px solid #F3F4F6;\n}\n\n.menu-item.logout:hover {\n  background: #FEF2F2;\n}\n\n/* ===== MAIN CONTENT ===== */\n.app-main-integrated {\n  height: 100vh;\n  width: 100vw;\n  position: relative;\n}\n\n.map-container {\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n\n.map {\n  height: 100%;\n  width: 100%;\n  border-radius: 0;\n}\n\n.map-loading,\n.map-error {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  background: rgba(255, 255, 255, 0.95);\n  padding: 32px;\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #E5E7EB;\n  border-top: 4px solid #F97316;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 16px;\n}\n\n.loading-spinner.small {\n  width: 20px;\n  height: 20px;\n  border-width: 2px;\n  margin: 0;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* ===== PLACES PANEL ===== */\n.floating-places-panel {\n  position: fixed;\n  top: 80px;\n  left: 16px;\n  width: 320px;\n  max-height: calc(100vh - 96px);\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(12px);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  z-index: 900;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Hide mobile search controls on desktop */\n.mobile-search-controls {\n  display: none;\n}\n\n.places-scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 8px 8px 8px;\n}\n\n.places-scroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.places-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.places-scroll::-webkit-scrollbar-thumb {\n  background: #CBD5E1;\n  border-radius: 3px;\n}\n\n.places-scroll::-webkit-scrollbar-thumb:hover {\n  background: #94A3B8;\n}\n\n/* ===== PLACE CARDS ===== */\n.place-card-compact {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px;\n  margin-bottom: 8px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  backdrop-filter: blur(8px);\n}\n\n.place-card-compact:hover {\n  border-color: rgba(249, 115, 22, 0.3);\n  box-shadow: 0 8px 32px rgba(249, 115, 22, 0.15);\n  transform: translateY(-2px);\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.place-card-compact.selected {\n  border-color: rgba(249, 115, 22, 0.4);\n  background: rgba(255, 247, 237, 0.9);\n  box-shadow: 0 6px 24px rgba(249, 115, 22, 0.2);\n}\n\n.place-main-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.place-main-info h4 {\n  margin: 0 0 4px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #1F2937;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.place-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.place-rating,\n.place-price {\n  font-size: 12px;\n  color: #6B7280;\n}\n\n.interest-button-compact {\n  background: #F3F4F6;\n  border: 1px solid #D1D5DB;\n  border-radius: 4px;\n  padding: 6px 8px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.interest-button-compact:hover {\n  background: #E5E7EB;\n  border-color: #9CA3AF;\n}\n\n.interest-button-compact.interested {\n  background: #D1FAE5;\n  border-color: #10B981;\n  color: #10B981;\n}\n\n.interest-button-compact.interested:hover {\n  background: #A7F3D0;\n}\n\n/* Loading Places State */\n.loading-places {\n  text-align: center;\n  padding: 40px 20px;\n  color: #6B7280;\n}\n\n.loading-places p {\n  margin: 16px 0 0 0;\n  font-size: 14px;\n}\n\n/* No Places State */\n.no-places {\n  text-align: center;\n  padding: 40px 20px;\n  color: #6B7280;\n}\n\n.no-places-emoji {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.no-places p {\n  margin: 4px 0;\n  font-size: 14px;\n}\n\n/* ===== PLACE DETAILS ===== */\n.selected-place-detail {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  width: 320px;\n  background: rgba(255, 255, 255, 0.98);\n  backdrop-filter: blur(16px);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  z-index: 900;\n  animation: slideUp 0.3s ease-out;\n  overflow: hidden;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.detail-header {\n  display: flex;\n  justify-content: flex-end;\n  padding: 12px 16px 0;\n}\n\n.close-detail {\n  background: #F3F4F6;\n  border: none;\n  border-radius: 4px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 16px;\n  color: #6B7280;\n  transition: all 0.2s ease;\n}\n\n.close-detail:hover {\n  background: #E5E7EB;\n  color: #374151;\n}\n\n.detail-content {\n  padding: 0 20px 20px;\n}\n\n.detail-content h3 {\n  margin: 0 0 8px 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.detail-address {\n  margin: 0 0 12px 0;\n  font-size: 14px;\n  color: #6B7280;\n  line-height: 1.4;\n}\n\n.detail-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.detail-rating,\n.detail-price {\n  font-size: 14px;\n  color: #374151;\n}\n\n.detail-actions {\n  text-align: center;\n}\n\n.interest-button-large {\n  width: 100%;\n  background: #F97316;\n  border: none;\n  border-radius: 6px;\n  padding: 12px 16px;\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-bottom: 8px;\n}\n\n.interest-button-large:hover {\n  background: #EA580C;\n  transform: translateY(-1px);\n}\n\n.interest-button-large.interested {\n  background: #10B981;\n}\n\n.interest-button-large.interested:hover {\n  background: #059669;\n}\n\n.interest-status {\n  font-size: 12px;\n  color: #6B7280;\n  line-height: 1.4;\n}\n\n/* ===== MODALS ===== */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  backdrop-filter: blur(4px);\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #E5E7EB;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.close-button {\n  background: #F3F4F6;\n  border: none;\n  border-radius: 4px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 18px;\n  color: #6B7280;\n  transition: all 0.2s ease;\n}\n\n.close-button:hover {\n  background: #E5E7EB;\n  color: #374151;\n}\n\n.modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  max-height: calc(80vh - 80px);\n}\n\n/* Profile Info */\n.profile-info {\n  display: flex;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.profile-avatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid #E5E7EB;\n}\n\n.profile-details {\n  flex: 1;\n}\n\n.profile-field {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  border-bottom: 1px solid #F3F4F6;\n}\n\n.profile-field:last-child {\n  border-bottom: none;\n}\n\n.profile-field label {\n  font-weight: 500;\n  color: #374151;\n  font-size: 14px;\n}\n\n.profile-field span {\n  color: #6B7280;\n  font-size: 14px;\n}\n\n/* Settings Content */\n.settings-content {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.settings-message {\n  max-width: 300px;\n  margin: 0 auto;\n}\n\n.settings-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.settings-message h3 {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.settings-message p {\n  margin: 0;\n  color: #6B7280;\n  line-height: 1.5;\n}\n\n/* ===== RESPONSIVE DESIGN ===== */\n@media (max-width: 768px) {\n  .floating-header {\n    left: 0;\n    right: 0;\n    top: 0;\n    border-radius: 0;\n  }\n  \n  .header-content {\n    padding: 12px 16px;\n    gap: 12px;\n    flex-wrap: nowrap;\n    align-items: center;\n  }\n  \n  .logo-section {\n    flex: 1;\n    min-width: 0;\n  }\n  \n  .logo {\n    font-size: 20px;\n  }\n  \n  .tagline {\n    font-size: 12px;\n  }\n  \n  .search-controls-inline {\n    display: none;\n  }\n  \n  .header-right-section {\n    flex-shrink: 0;\n    gap: 12px;\n  }\n  \n  .user-profile {\n    min-width: 44px;\n    max-width: 44px;\n    padding: 8px;\n    justify-content: center;\n  }\n  \n  .user-name {\n    display: none;\n  }\n  \n  .dropdown-arrow {\n    display: none;\n  }\n  \n  .app-main-integrated {\n    display: flex;\n    flex-direction: column;\n    padding-top: 70px;\n    height: 100vh;\n  }\n  \n  .map-container {\n    height: 50vh;\n    width: 100%;\n    flex-shrink: 0;\n  }\n  \n  .floating-places-panel {\n    position: relative;\n    top: auto;\n    left: auto;\n    right: auto;\n    bottom: auto;\n    width: 100%;\n    max-width: none;\n    height: auto;\n    max-height: none;\n    border-radius: 0;\n    border: none;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    box-shadow: none;\n    transform: none;\n    transition: none;\n    flex: 1;\n    background: rgba(255, 255, 255, 0.98);\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n  \n  .mobile-search-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 12px 16px;\n    background: rgba(248, 250, 252, 0.9);\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n    flex-wrap: wrap;\n  }\n  \n  .selected-place-detail {\n    position: fixed;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    width: calc(100vw - 20px);\n    max-width: 300px;\n    z-index: 1000;\n  }\n  \n  .modal-content {\n    width: 95%;\n    margin: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header-content {\n    padding: 10px 12px;\n    gap: 8px;\n  }\n  \n  .logo {\n    font-size: 18px;\n  }\n  \n  .tagline {\n    font-size: 11px;\n  }\n  \n  .user-profile {\n    min-width: 40px;\n    max-width: 40px;\n    padding: 6px;\n  }\n  \n  .user-avatar {\n    width: 28px;\n    height: 28px;\n  }\n  \n  .app-main-integrated {\n    padding-top: 60px;\n  }\n  \n  .map-container {\n    height: 40vh;\n  }\n  \n  .floating-places-panel {\n  }\n  \n  .selected-place-detail {\n    max-width: none;\n    top: 45%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
